import React, { useState, useEffect } from "react";
import { getTemplate } from "./TableStrategies/TableFactory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DynamicTable = ({ sections, onSubmit }) => {
  const initializeState = (sections) => {
    const state = {};
    sections.forEach((section) => {
      section.rows.forEach((row) => {
        row.values.forEach((name) => {
          state[name] = ""; // Начальное значение для каждого инпута
        });
      });
    });
    return state;
  };

  const [inputValues, setInputValues] = useState(initializeState(sections));
  const [disabledInputs, setDisabledInputs] = useState({});

  // Функция для применения правил
  const applyRules = (rules) => {
    const newDisabledInputs = { ...disabledInputs };

    if (rules) {
      rules.forEach((rule) => {
        if (rule.type === "sum") {
          const sum = rule.sources.reduce(
            (acc, source) => acc + (parseFloat(inputValues[source]) || 0),
            0
          );
          setInputValues((prevState) => ({
            ...prevState,
            [rule.target]: sum.toString(),
          }));
        }

        if (rule.type === "gte") {
          const sum = rule.sources.reduce(
            (acc, source) => acc + (parseFloat(inputValues[source]) || 0),
            0
          );
          if (parseFloat(inputValues[rule.target]) < sum) {
            toast.error("Значение может быть только больше или равно");
            setInputValues((prevState) => ({
              ...prevState,
              [rule.target]: sum.toString(),
            }));
          }
        }

        if (rule.type === "disabled") {
          newDisabledInputs[rule.target] = true;
        }
      });

      setDisabledInputs(newDisabledInputs);
    }
  };

  // Применяем правила при изменении inputValues
  useEffect(() => {
    sections.forEach((section) => {
      if (section.rules) {
        applyRules(section.rules);
      }
    });
  }, [inputValues, sections]);

  const handleInputChange = (name, newValue) => {
    setInputValues((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };
  const handleSubmit = () => {
    // Фильтруем только незаблокированные значения
    const validInputs = Object.keys(inputValues).reduce((acc, key) => {
      if (!disabledInputs[key]) {
        acc[key] = inputValues[key];
      }
      return acc;
    }, {});

    if (onSubmit) {
      onSubmit(validInputs); // Передаем данные в функцию-обработчик
    }
  };

  return (
    <div>
      <ToastContainer />
      {sections.map((section, sectionIndex) => {
        const Template = getTemplate(section.type);
        return Template ? (
          <Template
            key={sectionIndex}
            {...section}
            inputValues={inputValues}
            disabledInputs={disabledInputs}
            onChange={handleInputChange}
          />
        ) : null;
      })}

      <button
        onClick={handleSubmit}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: "#007BFF",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        Отправить
      </button>
    </div>
  );
};

export default DynamicTable;
